/* Tiba Salud — Barra de recompensas.
 * El markup lo renderiza Liquid y el theme lo reemplaza en cada cambio de carrito
 * (sections API). Este script solo:
 *  1. anima el relleno desde el valor anterior al nuevo,
 *  2. detecta cuando se desbloquea un nivel nuevo y marca ese hito,
 *  3. respeta prefers-reduced-motion (el CSS quita el movimiento).
 */
(function () {
  'use strict';

  var FILL_KEY = 'tiba_rp_fill';
  var LEVEL_KEY = 'tiba_rp_level';
  var CELEBRATE_MS = 1400;

  function read(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }
  function write(key, value) {
    try { sessionStorage.setItem(key, String(value)); } catch (e) { /* modo privado */ }
  }

  function init(el) {
    if (!el || el.dataset.rpInit) return;
    el.dataset.rpInit = '1';

    var target = parseFloat(el.dataset.rpFill || '0');
    var level = parseInt(el.dataset.rpLevel || '0', 10);
    var prevFill = parseFloat(read(FILL_KEY));
    var prevLevel = parseInt(read(LEVEL_KEY), 10);

    if (isNaN(prevFill)) prevFill = 0;
    if (isNaN(prevLevel)) prevLevel = level;

    // 1. Relleno: arrancar en el valor anterior y dejar que la transición CSS llegue al nuevo.
    el.style.setProperty('--rp-fill', prevFill);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.style.setProperty('--rp-fill', target);
      });
    });

    // 2. Nivel nuevo desbloqueado: un solo momento, en el hito correspondiente.
    if (level > prevLevel) {
      var step = el.querySelector('[data-rp-step="' + level + '"]');
      el.classList.add('rp--celebrate');
      if (step) step.classList.add('rp-step--just-unlocked');
      var headline = el.querySelector('.rp-headline');
      if (headline) headline.classList.add('rp-headline--enter');
      window.setTimeout(function () {
        el.classList.remove('rp--celebrate');
        if (step) step.classList.remove('rp-step--just-unlocked');
      }, CELEBRATE_MS);
    }

    write(FILL_KEY, target);
    write(LEVEL_KEY, level);
  }

  function scan(root) {
    var nodes = (root || document).querySelectorAll('.reward-progress:not([data-rp-init])');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  function observe() {
    var targets = [document.getElementById('Cart-Drawer'), document.getElementById('Cart')].filter(Boolean);
    if (!('MutationObserver' in window) || !targets.length) return;
    var mo = new MutationObserver(function () { scan(); });
    targets.forEach(function (t) { mo.observe(t, { childList: true, subtree: true }); });
  }

  function boot() {
    scan();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Respaldo por si el drawer se monta después (theme editor, carga diferida).
  document.addEventListener('cart-drawer:open', function () { scan(); });
  document.addEventListener('cart:item-added', function () { scan(); });
  document.addEventListener('line-item:change:end', function () { scan(); });
})();
